<template>
  <div>
    <api-loading :show="loading"></api-loading>
    <Sideleft
      :status="filters.status"
      :sideStatus="leftSideStatus"
      :distributor_name="filters.distributorName"
      @changeStatus="changeLeftSideStatus"
      @filtrate="filtrate"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :num="totalCountDistributor"
        :offerStatus="filters.status"
        :distributorName="filters.distributorName"
        :distributorId="filters.distributorId"
        @clearKey="clearKey"
        @toOffer="toOffer"
      />
      <router-view
        v-if="isSysRights('OfferList.findsBySupplie')"
        :first_loading="firstLoading"
        :items="offerList"
      ></router-view>
      <no-rights v-else></no-rights>
      <Pagination
        class="pd-x-20 pd-sm-x-30"
        v-if="!firstLoading"
        :cur="page"
        :all="totalPage"
        :path="'/offer/'"
        :page_size_select="pageSizeSelect"
        :rows_per_page="rowsPerPage"
        :total_count="totalCount"
        @changeRPPage="changeRPPage"
        @gotoPage="toPage"
      />
    </div>
    <ModalFindDistributor :open="openFindeDistributor" />
  </div>
</template>

<script>
import Sideleft from "./left-side.vue";
import Header from "./header.vue";
import { pagination } from "@components/pagination.js"; //分页
import ModalFindDistributor from "./modal-find-distributor.vue";

export default {
  data() {
    return {
      firstLoading: false,
      loading: false,
      leftSideStatus: store.get("leftSideStatus"), //左边栏状态
      pageSizeSelect: [10, 20, 50],
      page: this.$route.params.page ? this.$route.params.page : 1,
      rowsPerPage: parseInt(store.get("s-offer-rowsPerPage"))
        ? parseInt(store.get("s-offer-rowsPerPage"))
        : 10,
      totalPage: 0,
      totalCount: 0,
      offerList: [],
      filters: {
        status: this.$route.query.status ? this.$route.query.status : "",
        distributorName: "",
        distributorId: "",
      },
      openFindeDistributor: Symbol(),
      totalCountDistributor: 0,
      distributorItem: [],
      domain: window.location.host,
    };
  },
  components: {
    Sideleft,
    Header,
    Pagination: pagination,
    ModalFindDistributor,
  },
  mounted() {
    //展开折叠搜索
    let user = store.get("userInfo");
    let that = this;
    if (this.$parent.sideTop) {
      if ($(".br-subleft").outerHeight() > 56) {
        $(".br-subleft").addClass("left-more ht-54 ht-auto");
        $(".br-subleft").append(
          `<a href="javascript:;" class="d-flex align-items-center more-btn"><span class=" mg-r-5 tx-info">${this.$t(
            "app.更多"
          )}</span><i aria-hidden="true" class="tx-info fa fa-angle-down"></i></a>`
        );
        $(".more-btn").on("click", function () {
          if ($(this).find("i").hasClass("fa-angle-down")) {
            $(this).find("span").text(that.$t("app.隐藏"));
            $(this).parent(".br-subleft").removeClass("ht-54");
            $(this)
              .find("i")
              .removeClass("fa-angle-down")
              .addClass("fa-angle-up");
          } else {
            $(this).find("span").text(that.$t("app.更多"));
            $(this).parent(".br-subleft").addClass("ht-54");
            $(this)
              .find("i")
              .addClass("fa-angle-down")
              .removeClass("fa-angle-up");
          }
          let bodyH = parseInt($(window).height());
          if (user.source == 9) {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 340 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 340 + "px");
            }
          } else {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 260 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 260 + "px");
            }
          }
        });
      }
    }
    this.getOffer();
  },
  watch: {
    $route: "gotoPage",
    rowsPerPage: function () {
      store.set("s-offer-rowsPerPage", this.rowsPerPage);
    },
  },
  methods: {
    toOffer() {
      //    this.openFindeDistributor = Symbol();
      //    $('#modalFindDistributor').modal('show');
      if (this.totalCountDistributor == 1) {
        let url =
          "//" +
          this.domain +
          "/share-price/#/?dId=" +
          this.distributorItem[0].distributorId;
        window.open(url, "offerShare", undefined, true);
        localStorage.setItem(
          "sharePriceCatagoryIds",
          this.distributorItem[0].categoryId
        );
      } else if (this.totalCountDistributor > 1) {
        this.$router.push({ path: "/distributor-page/" });
      }
    },
    getDistributor() {
      $.api_call(
        "api.Distributor.findBySupplier",
        {
          page: 1,
          rowsPerPage: 1,
        },
        (r) => {
          if (r.ErrorCode == "9999") {
            this.distributorItem = r.Data.Results;
            this.totalCountDistributor = r.Data.Pagination.totalCount;
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    getOffer() {
      this.getDistributor();
      if (!this.isSysRights("OfferList.findsBySupplier")) return false;
      this.loading = true;
      $.api_call(
        "api.OfferList.findsBySupplier",
        {
          page: this.page,
          rowsPerPage: this.rowsPerPage,
          status: this.filters.status,
          distributorId: this.filters.distributorId,
        },
        (r) => {
          this.loading = false;
          this.firstLoading = false;
          if (r.ErrorCode == "9999") {
            this.offerList = r.Data.Results;
            this.totalPage = r.Data.Pagination.totalPage;
            this.totalCount = r.Data.Pagination.totalCount;
            $("html,body").scrollTop(0);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    changeLeftSideStatus() {
      //改变左边栏状态
      this.leftSideStatus = !this.leftSideStatus;
      store.set("leftSideStatus", this.leftSideStatus);
    },
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.replace({ path: "/offer/" + 1 });
      if (page == 1) {
        this.getOffer();
      }
    },
    toPage(num) {
      let page = this.page;
      this.$router.replace({ path: "/offer/" + num });
      if (page == num) {
        this.getOffer();
      }
    },
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getOffer();
    },
    filtrate(status, name, id) {
      this.filters.status = status;
      this.filters.distributorName = name;
      this.filters.distributorId = id;
      //筛选都回第一页
      this.toPage(1);
    },
    clearKey(type) {
      switch (type) {
        case "name":
          this.filters.distributorName = "";
          this.filters.distributorId = "";
          break;
        case "status":
          this.filters.status = "";
          break;
      }
      this.toPage(1);
    },
  },
};
</script>

